import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../utils/AuthContext';
import styles from './Header.module.css';

export default function Header() {
  const { user } = useAuth();
  const location = useLocation();
  const [moreOpen, setMoreOpen] = useState(false);

  const isActive = (to) =>
    location.pathname === to || location.pathname.startsWith(`${to}/`);

  const link = (to, label) => (
    <Link
      to={to}
      className={`${styles.navLink} ${isActive(to) ? styles.active : ''}`}
    >
      {label}
    </Link>
  );

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.brand}>
          <Link to="/" className={styles.logoLink}>
            <span className={styles.logo}>ZeroAPI</span>
          </Link>
        </div>
        {user && (
          <nav className={styles.nav} aria-label="Primary">
            {link('/app', 'Home')}
            {link('/app/outcomes', 'Outcomes')}
            {link('/app/history', 'Proof & runs')}
            {link('/app/workflows', 'Workflows')}
            <div className={styles.moreWrap}>
              <button
                type="button"
                aria-expanded={moreOpen}
                aria-haspopup="true"
                onClick={() => setMoreOpen((o) => !o)}
                className={styles.navLink}
              >
                More ▾
              </button>
              {moreOpen && (
                <div role="menu" className={styles.moreMenu}>
                  {[
                    ['/app/integrations', 'Integrations'],
                    ['/app/settings', 'Settings'],
                    ['/app/tasks', 'Tasks'],
                    ['/app/files', 'Files'],
                    ['/app/analytics', 'Analytics'],
                  ].map(([to, label]) => (
                    <Link
                      key={to}
                      role="menuitem"
                      to={to}
                      onClick={() => setMoreOpen(false)}
                      className={`${styles.moreItem} ${isActive(to) ? styles.active : ''}`}
                    >
                      {label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
